const UpdatePage = () => {
  return <div>업데이트 예정......</div>;
};

export default UpdatePage;
